import { Form } from '@unform/web';
import React, { useRef, useState } from 'react';
import { useLanguage } from '../../../../../../hooks/Language';
import CreditCardForm from './modules/CreditCard';
import GeneralForm from './modules/GeneralForm';
import CurrencyInput from '../../../../../../components/Forms/MaskedCurrencyInput';
import CompleteSaleFields from '../../../CompleteSaleFields';
import { FiArrowRight } from 'react-icons/fi';
import calculateDiscount from '../../Functions/calculateDiscount';
import Input from '../../../../../DashboardPages/core/components/Forms/Input';
import MaskedInput from '../../../../../DashboardPages/core/components/Forms/MaskedInput';
import SelectSimple from '../../../../../../components/Forms/SelectSimple';
import { countries } from '../../../Login/countries';
import ReCAPTCHA from 'react-google-recaptcha';
import { recaptchaKey } from '../../../../../../config';
import getCep from '../../../../../../services/cep';
import { FormHandles } from '@unform/core';
import DisplayCartPrice from '../../../../../Products/modules/PaymentMethod/modules/DisplayCartPrice';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import * as Yup from 'yup';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import { useToast } from '../../../../../../hooks/Toast';
import states from 'src/pages/SignUp/FormContainer/states';
import CheckboxInput from 'src/components/Forms/CheckboxInput';
interface IProps {
    paymentMethod: 'credit_card' | 'boleto' | 'pix' | 'cortesy';

    cart: Array<Record<string, any>>;
    couponInfo?: Record<string, any>;
    changeInstallment: Function;
    installmentValue: number;
    quantity: number;
    sendPaymentRequest: Function;
    applyCoupon: Function;
    courtesyCode: string;
}

const PaymentMethodForm: React.FC<IProps> = ({ courtesyCode, paymentMethod, couponInfo, cart, changeInstallment, installmentValue, quantity, sendPaymentRequest, applyCoupon }) => {

    const { translate } = useLanguage();
    const product = cart?.[0] || {};
    const recaptchaRef = useRef(null);
    const [type, setType] = useState('cpf');
    const [countryISO, setCountryISO] = useState('BR');
    const [company, setCompany] = useState('');
    const formRef = useRef<FormHandles>(null);
    const { addLoading, removeLoading } = useLoading();
    const { addToast } = useToast();

    const paymentMethodElements = {

        boleto: () => <GeneralForm />,
        pix: () => <GeneralForm />,
        cortesy: () => <></>,
        courtesy: () => <></>,
    }

    const getCaptchaValue = (elem: any): string => {
        return elem?.getValue ? elem?.getValue() : '';
    };


    const getCepFromApi = async (value: string): Promise<void> => {
        const cepResponse = await getCep(value);

        if (!cepResponse.error) {
            formRef?.current?.setFieldValue('address', cepResponse.logradouro);
            formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
            formRef?.current?.setFieldValue('city', cepResponse.localidade);
            formRef?.current?.setFieldValue('state', cepResponse.uf);
        }
    };



    const validate = async (data) => {
        addLoading({ title: 'validando', key: 'validando' });
        try {
            formRef.current?.setErrors({});

            data.extra_5 = data?.extra_5?.[0] ? data?.extra_5?.[0] : '';
            const schema = Yup.object().shape({
                name: Yup.string().required(`${translate('Nome')} ${translate('obrigatório')}`),
                email: Yup.string().email().required(`${translate('E-mail')} ${translate('obrigatório')}`),
                phone: Yup.string().required(`${translate('Telefone')} ${translate('obrigatório')}`),
                rg: Yup.string().required(`${translate('RG')} ${translate('obrigatório')}`),
                company: Yup.string().required(`${translate('Instituição')} ${translate('obrigatório')}`),
                position: Yup.string().required(`${translate('Empresa')} ${translate('obrigatório')}`),
                extra_1: Yup.string().required(`${translate('CNPJ da instituição')} ${translate('obrigatório')}`),
                extra_4: Yup.string().required(`${translate('Estado da instituição')} ${translate('obrigatório')}`),
                extra_5: Yup.string().required(`${translate('Data de nascimento')} ${translate('obrigatório')}`),
                document_number: Yup.string()
                    .min(11, `${translate('CPF')} ${translate('obrigatório')}`)
                    .required(`${translate('CPF')} ${translate('obrigatório')}`),
            });


            data.document_number = data?.document_number?.toString().replace(/[^0-9]/g, '') || '';
            data.company_document_number = data?.company_document_number?.toString().replace(/[^0-9]/g, '') || '';


            await schema.validate(data, { abortEarly: false });




            sendPaymentRequest({ data, paymentMethod: calculateDiscount(couponInfo, cart).discountedValue > 0 ? paymentMethod : 'boleto', cart, coupon: couponInfo, courtesy: courtesyCode });
            removeLoading('validando');

        }
        catch (err) {
            if (err instanceof Yup.ValidationError) {
                const errors = getValidationErrors(err);

                formRef.current?.setErrors(errors);

                const errorInfo = err.errors.reduce((error, prev) => {
                    prev = `${prev}, ${error}`;
                    return prev;
                });
                removeLoading('validando')
                addToast({
                    type: 'error',
                    title: 'Erro de validação',
                    description: errorInfo,
                });
            }
            console.log(err)
            removeLoading('validando')
        }




    }



    return <>

        <Form className="form"
            ref={formRef}
            initialData={{ country: "BR", installments: installmentValue, quantity: quantity, document_type: type }}
            onSubmit={(data) => { data.recaptcha = getCaptchaValue(recaptchaRef?.current); validate(data) }}

        >


            {product.fields && product.fields.length > 0 ? <>  <CompleteSaleFields applyCoupon={applyCoupon} fields={product.fields} />
                <br />
            </> : <></>}

            <div className='outerBlock'>
                <h2 style={{ margin: ' 0px', fontSize: '14px', marginBottom: '5px', width: '100%', color: '#333', borderBottom: '3px solid #0a4f4b', padding: '5px 0px', textAlign: 'left' }}>{translate('4. Dados do Inscrito(a)')}</h2>
                <SelectSimple setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={'Pais'} />

                {countryISO === 'BR' ?
                    <SelectSimple options={states} name="state" label={'Estado'} />
                    : <Input name="state" placeholder="Estado" />}
                <Input name="city" placeholder="Município" />
                <Input type='text' name='name' placeholder='Nome completo' />
                <Input type='text' name='email' placeholder='E-mail' />
                {countryISO === 'BR' ? <MaskedInput
                    mask="999.999.999-99"
                    name="document_number"
                    placeholder={translate('CPF')}
                /> : <Input name="document_number"
                    placeholder={translate('Nº do documento')} />}

                <MaskedInput
                    mask="99/99/9999"
                    name="extra_5"
                    placeholder="Data de nascimento"
                />


                {countryISO === 'BR' ? <MaskedInput mask='(99) 99999.9999' type='text' name='phone' placeholder='Celular / Whatsapp' />
                    : <Input name="phone"
                        placeholder={translate('Número do telefone')} />}

                <Input type='text' name='rg' placeholder='RG' />
                <Input type='text' name='company' placeholder='Instituição' />
                <Input type='text' name='position' placeholder='Cargo na instituição' />
                <SelectSimple options={states} name="extra_4" label={'Estado da instituição'} />
                <MaskedInput

                    mask="99.999.999/9999-99"
                    name="extra_1"
                    placeholder={`${translate('CNPJ da instituição')}`}
                />

                <p style={{ color: '#333', padding: '20px 0px' }}>Se você vem de outro estado (que não o RS), por favor responda: </p>
                <SelectSimple options={[
                    { label: 'Sim', value: 'Sim' },
                    { label: 'Não', value: 'Não' }


                ]} name="inscricao_1" label={'Já planejou o seu transporte entre o Aeroporto Salgado Filho (POA) e a cidade de Gramado?'} />


            </div>

            <div style={{ marginTop: '10px' }} />



            <div className='outerBlock'>

                <h2 style={{ margin: ' 0px', fontSize: '14px', marginBottom: '5px', width: '100%', color: '#333', borderBottom: '3px solid #c3a257', padding: '5px 0px', textAlign: 'left' }}>{translate('Emitir como Pessoa Física ou PJ?')}</h2>


                <SelectSimple index={100} style={{ zIndex: 100000 }}
                    setCallback={(value) => setType(value)}
                    options={[
                        { value: 'cpf', label: translate('Pessoa Física') },
                        {
                            value: 'cnpj',
                            label: translate('Entidade / Pessoa Jurídica'),
                        },
                    ]}
                    name="document_type"

                    label={translate('Emitir como')}
                />

                {type === 'cnpj' ? <>

                    <Input type='text' name='company' placeholder='Razão social' />
                    <MaskedInput mask='99.999.999/9999-99' type='text' name='company_document_number' placeholder='CNPJ' />



                </> : <></>}

            </div>

            <CheckboxInput
                style={{ display: 'flex' }}
                name="extra_5"
                unique={true}
                preText={(
                    <>
                        {' '}
                        Estou ciente de que estou fornecendo à Tchê Previdência e seus parceiros meus contatos gerais, os quais são dados pessoais protegidos pela Lei Geral de Proteção de Dados Brasileira, para gestão de relacionamento e marketing da empresa, conforme Política de Privacidade disponível neste site.

                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Sim, autorizo a liberação dos meus dados (nome, empresa, telefone e e-mail) para uso da Tchê Previdência e seus parceiros.`,
                        label: translate('Sim, autorizo a liberação dos meus dados (nome, empresa, telefone e e-mail) para uso da Tchê Previdência e seus parceiros.'),
                        value: `Sim, autorizo a liberação dos meus dados (nome, empresa, telefone e e-mail) para uso da Tchê Previdência e seus parceiros.`,
                    },
                    {
                        id: `Não autorizo a liberação dos meus dados para uso da Tchê Previdência e seus parceiros.`,
                        label: translate('Não autorizo a liberação dos meus dados para uso da Tchê Previdência e seus parceiros.'),
                        value: `Não autorizo a liberação dos meus dados para uso da Tchê Previdência e seus parceiros.`,
                    },
                ]}
            />

            <p style={{ fontSize: '12px', textAlign: 'center', width: '100%', margin: '10px 0px' }}>Ao me inscreve, afirmo que li e concordo com a política de privacidade e os termos de cancelamento e reembolso desta plataforma.</p>
            <aside style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', alignItems: 'center' }}>
                <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />

            </aside>



            <button className='greenButton2 buttonColored' type="submit">
                {translate('Finalizar')}

            </button>

        </Form>
    </>

};
export default PaymentMethodForm;
